class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
    fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        // check if cart item is a pattern type
        let cartItems = document.querySelectorAll(".cart-item");
        let patternItems = 0;
        cartItems.forEach((e) => {
          if (e.dataset.type === "Strikkeopskrift") {
            data.items.forEach((item) => {
              if (item.product_id == e.dataset.id) {
                patternItems += item.quantity;
              }
            })
          }
        });
      });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      
        // ✅ After DOM is re-rendered, update the free-shipping bar once
        if (window.updateFreeShippingBar) window.updateFreeShippingBar();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

updateQuantity(line, quantity, name, variantId) {
  this.enableLoading(line);


  const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
  const type = quantityElement.getAttribute('data-type') || '';

  const body = JSON.stringify({
    line,
    quantity,
    sections: this.getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname,
  });

  let uniqueId = null;

  // Step 1: Fetch the cart FIRST and capture values
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const itemToUpdate = cart.items[line - 1];
      if (itemToUpdate) {
        uniqueId = itemToUpdate.properties?._UniqueId?.toString() || null;
      }

      // Step 2: Perform the quantity update
      return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body });
    })
    .then(response => response.text())
    .then(state => {
      const parsedState = JSON.parse(state);

      const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll('.cart-item');

      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute('value');
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });

      // ✅ After DOM is re-rendered, update the free-shipping bar once
      if (window.updateFreeShippingBar) window.updateFreeShippingBar();
      
      // Step 3: Yarn removal logic
      const updatedItem = parsedState.items[line - 1];
      if (type == "Knit Kits") {
        if (uniqueId) {

        fetch('/cart.js')
          .then(res => res.json())
          .then(async (cart) => {
            const matchingItems = cart.items.filter(item =>
              item.properties &&
              item.properties._UniqueId &&
              item.properties._UniqueId.toString() === uniqueId
            );

            if (matchingItems.length === 0) return;

            for (const item of matchingItems) {
              // const yarnQuantity = parseInt(item.properties._YarnQuantity || '0', 10);
              // const yarnAdjustment = yarnQuantity * diff;
              // const newYarnQty = Math.max(0, item.quantity + yarnAdjustment);

              try {
                await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                  },
                  body: JSON.stringify({
                    id: item.key,
                    quantity: 0, // Set to 0 to remove the item
                  }),
                });
              } catch (e) {
                console.error(`Failed to update item ${item.key}`, e);
              }
            }

            // Fetch updated cart after all changes
            // const updatedCartRes = await fetch('/cart.js');
            // const updatedCart = await updatedCartRes.json();

            // publish(PUB_SUB_EVENTS.cartUpdate, { source: 'yarn-update', cartData: updatedCart });
          });
        }
      }


      // Focus trap and message updates
      let message = '';
      const updatedValue = updatedItem ? updatedItem.quantity : undefined;
      if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
        message = typeof updatedValue === 'undefined'
          ? window.cartStrings.error
          : window.cartStrings.quantityError.replace('[quantity]', updatedValue);
      }
      this.updateLiveRegions(line, message);

      const lineItem =
        document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper
          ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
          : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
      } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
      }

      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
    })
    .catch(() => {
      this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      errors.textContent = window.cartStrings.error;
    })
    .finally(() => {
      this.disableLoading(line);
    
      // ✅ Safety net: after all promises & DOM swaps have finished, refresh the bar once
      if (window.updateFreeShippingBar && document.querySelector('.cart-shipping__wrapper')) {
        setTimeout(() => window.updateFreeShippingBar(), 0); // or: requestAnimationFrame(() => window.updateFreeShippingBar());
      }
    });
}

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
